type FooterPropsType = {
  footer: JSX.Element | string;
};

export const Footer: React.FC<FooterPropsType> = (props) => {
  return <div className="text-center h6 my-4">{props.footer}</div>;
};
